import React, { useEffect, useState } from 'react';
import './ATPRankings.css';

const API_BASE = 'http://localhost:5000'//'https://real-app-mehul-2.onrender.com';

// const LEAGUE_COLORS = {
//   '39': { // EPL
//     champions: { range: [1, 4], color: '#10b981' },
//     europa: { range: [5, 5], color: '#3b82f6' },
//     // conference: { range: [6, 6], color: '#f59e0b' },
//     relegation: { range: [18, 20], color: '#ef4444' },
//   },
//   '140': { // La Liga
//     champions: { range: [1, 4], color: '#10b981' },
//     europa: { range: [5, 5], color: '#3b82f6' },
//     conference: { range: [6, 6], color: '#f59e0b' },
//     relegation: { range: [18, 20], color: '#ef4444' },
//   },
//   '135': { // Serie A
//     champions: { range: [1, 4], color: '#10b981' },
//     europa: { range: [5, 5], color: '#3b82f6' },
//     conference: { range: [6, 6], color: '#f59e0b' },
//     relegation: { range: [18, 20], color: '#ef4444' },
//   },
//   '61': { // Ligue 1
//     champions: { range: [1, 3], color: '#10b981' },
//       champions_qual: { range: [4, 4], color: '#3b82f6' },
//     europa: { range: [5, 5], color: '#f59e0b' },
//     conference: { range: [6, 6], color: '#24befb' },
//     relegation_playoff: { range: [16, 16], color: '#f59e0b' },
//     relegation: { range: [17, 18], color: '#ef4444' },
//   },
//   '21': { // Bundesliga
//     champions: { range: [1, 4], color: '#10b981' },
//     europa: { range: [5, 5], color: '#3b82f6' },
//     conference: { range: [6, 6], color: '#c60bf5' },
//     relegation_playoff: { range: [16, 16], color: '#f59e0b' },
//     relegation: { range: [17, 18], color: '#ef4444' },
//   }
// };

// const getSidebarColor = (rank, leagueId) => {
//   const rules = LEAGUE_COLORS[leagueId];
//   if (!rules) return { borderLeft: '4px solid transparent' };
  
//   for (const rule of Object.values(rules)) {
//     if (rank >= rule.range[0] && rank <= rule.range[1]) {
//       return { borderLeft: `4px solid ${rule.color}` };
//     }
//   }
//   return { borderLeft: '4px solid transparent' };
// };

const RankingsTable = () => {
  const [standings, setStandings] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    setError(null);
    fetch(`${API_BASE}/api/tennis/atp-rankings`)
      .then(res => res.json().then(data => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (ok && Array.isArray(data)) {
          setStandings(data);
          setError(null);
        } else {
          setStandings([]);
          setError(data?.error || 'Failed to load standings');
        }
      })
      .catch(() => {
        setStandings([]);
        setError('Failed to load standings');
      });
  }, []);

  const rows = Array.isArray(standings) ? standings : [];

  return (
    <div className="standingsTableWrap">
      {error && <p className="standingsError">{error}</p>}
      <table className="standingsTable">
        <thead className="standingsThead">
          <tr>
            <th className="standingsTh">RANK</th>
            <th className="standingsTh">PLAYER NAME</th>
            <th className="standingsTh">AGE</th>
            <th className="standingsTh">POINTS</th>
            <th className="standingsTh">POINT CHANGE</th>
            <th className="standingsTh">TOURNAMENTS PLAYED</th>
            <th className="standingsTh">POINTS DROPPING</th>
            <th className="standingsTh">NEXT BEST</th>
            {/* <th className="standingsTh">GD</th>
            <th className="standingsTh">P</th> */}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id ?? row.rank} className={`standingsRow `}>
              <td className="standingsTd standingsTdRank" >{row.rank}</td>
              <td className="standingsTd standingsTdTeam">
                <span>{row.player_name}</span>
              </td>
              <td className="standingsTd">{row.age}</td>
              <td className="standingsTd">{row.points}</td>
              <td className="standingsTd">{row.point_change || '-'}</td>
              <td className="standingsTd">{row.tournaments_played || '-'}</td>
              <td className="standingsTd">{row.points_dropping || '-'}</td>
              <td className="standingsTd">{row.next_best || '-'}</td>
              {/* <td className="standingsTd">{row.goalsDiff || '0'}</td>
              <td className="standingsTd standingsTdPts">{row.points}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RankingsTable;